<template>
  <div class="warp">
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加驻场')">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="delList">删除</el-button>
    </div>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="index" label="#" width="50" /> -->
        <el-table-column type="selection" width="55" />
        <el-table-column prop="companyAccount" label="企业账号" width="300" />
        <el-table-column prop="name" label="区域名称" width="300" />
        <el-table-column prop="companyList" label="已绑定公司">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.companyList" :key="index" class="flex-center">
              <div>{{ item.companyName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="memo" label="备注" width="200" />
        <el-table-column prop="address" label="操作" width="200">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑驻场', scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" style="margin: 6px 0 0" @click="del(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" width="800px" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :model="form" auto label-width="100px">
        <el-form-item label-width="100px" prop="companyId" label="发布企业账号：">
          <el-select v-model="test" filterable remote clearable placeholder="请输入企业账号进行搜索" :remote-method="getCompanyByAccount" :loading="loading">
            <el-option v-for="item in companyOpt" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <i v-show="searching" class="el-icon-loading" style="margin-left: 10px" />
        </el-form-item>
        <el-form-item label="驻场名称：" prop="name">
          <el-input v-model="form.name" style="max-width: 200px" />
        </el-form-item>
        <el-form-item label="绑定企业：" prop="companyIds">
          <el-checkbox-group v-model="form.companyIds" @change="changeCheckBox">
            <el-checkbox v-for="(item, index) in companyList" :key="index" :label="item.id" name="type">{{ item.companyName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注：" prop="memo">
          <el-input v-model="form.memo" style="max-width: 200px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加驻场')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  data() {
    return {
      tableData: [],
      tableH: 0,
      form: {
        companyAccountId: null,
        companyId: null,
        name: '',
        companyIds: [],
        memo: ''
      },
      type: [],
      visible: false,
      showDialog: false,
      loading: true,
      searching: false,
      dialogTitle: '',
      companyOpt: [],
      companyList: [],
      saveType: '',
      id: null,
      ids: [],
      test: '',
      multipleSelection: []
    }
  },
  mounted() {
    this.getTableList()
    this.getAllCompany()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log(val)
    },
    // 批量删除
    delList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('您并没有选中任何数据')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .yuzhiZhuchangDel(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    getCompanyByAccount(username) {
      this.searching = true
      this.companyOpt = []
      this.$api.company
        .reqCompanyByAccount({ username })
        .then((res) => {
          this.form.companyAccountId = res.companyAccountId
          this.companyOpt = [
            {
              value: res.companyId,
              label: res.companyName
            }
          ]
          this.searching = false
        })
        .catch(() => {
          this.companyOpt = []
          this.searching = false
        })
    },
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      this.test = ''
      this.companyOpt = []
      if (!row) return
      this.$nextTick(() => {
        const { companyAccountId, companyId, companyIds, name, memo, id } = row
        this.form = {
          companyAccountId,
          companyId,
          companyIds,
          name,
          memo,
          id
        }
        this.companyOpt = [
          {
            label: row.company.companyName,
            value: row.companyId
          }
        ]
        this.test = row.company.companyName
        this.companyOpt = JSON.parse(JSON.stringify(this.companyOpt))
      })
    },
    handleSubmit(isAdd) {
      if (!this.validateForm()) return
      const form = Object.assign({}, this.form)
      form.companyIds = form.companyIds.toString()
      if (isAdd) {
        this.loading = true
        this.$api.advance
          .zhuchangSave(form)
          .then((res) => {
            this.showDialog = false
            this.getTableList()
            this.getVerifyCount()
            this.$message.success('操作成功')
          })
          .catch((e) => {
            this.loading = false
            this.$message.error(e)
          })
      } else {
        try {
          this.$api.advance
            .zhuchangUpdate(form)
            .then((res) => {
              this.showDialog = false
              this.getTableList()
              this.getVerifyCount()
              this.$message.success('操作成功')
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e)
            })
        } catch (error) {
          console.log(error)
        }
      }
    },
    getTableList() {
      this.loading = true
      this.$api.advance
        .zhuChangList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          const ids = res.records.map((item) => item.companyAccountId).join(',')
          this.tableData.forEach((item) => {
            // console.log('item', item)
            this.getCompanyNameByIds({ ids: item.companyIds && item.companyIds.toString() }, item)
          })
          Promise.all([this.getCompanyName({ ids }), this.getCompanyAccountByIds({ ids })]).then(() => {
            console.log('123')
            this.loading = false
          })
          this.tableData.push()
          console.log(this.tableData, '打印该数据')
        })
        .catch((e) => {})
    },
    getCompanyName(data) {
      if (!data.ids) return Promise.resolve('1')
      return this.$api.common
        .reqCompanyAccountByIds(data)
        .then((res) => {
          const settingObj = res
          const settingArr = Object.keys(settingObj).map((key) => {
            // console.log(key); //为每个键名
            return settingObj[key] // 把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          })
          const companyList = settingArr
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyAccountId]
          })

          // 标记
          // this.tableData = JSON.parse(JSON.stringify(this.tableData))
          // console.log('data', this.tableData)
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    async getCompanyNameByIds(data, item) {
      const res = await this.$api.company.reqCompanyByIds(data)
      this.$set(item, 'companyList', res)
    },
    getCompanyAccountByIds(data) {
      return this.$api.company
        .reqCompanyAccountByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'companyAccount', res[item.companyAccountId] && res[item.companyAccountId].username)
            this.loading = false
          })
        })
        .catch(() => {})
    },
    getAllCompany() {
      this.$api.advance
        .allCompany()
        .then((res) => {
          this.companyList = res
        })
        .catch(() => {})
    },
    changeCheckBox(e) {
      console.log(e, 'changeCheckBox')
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.getTableList()
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.form)
      this.getTableList()
    },
    del(id) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.advance.zhuChangDelete({ ids: id }).then((res) => {
          this.getTableList()
        })
      })
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
